module.exports = __webpack_public_path__ + "static/media/icon-download-dark.a9d23e87.svg";